import {
  ProgramInviteFamilyOptions,
  ProgramInviteFamilyOptionsResponsePrograms,
  ProgramType,
} from '@swagger'

export const hasAvailableSpotsInPrograms = (
  programTypes: ProgramInviteFamilyOptionsResponsePrograms[]
): boolean => {
  const totalAvailableSpots = programTypes.reduce(
    (total, programType) => total + programType.availableSpots,
    0
  )

  return totalAvailableSpots !== 0
}

export const isProgramTypeInAvailableOptions = (
  type: ProgramType,
  options: ProgramInviteFamilyOptions[]
): boolean => {
  return options.some((option) => option.programType === type)
}
